import gql from 'graphql-tag';

export const UPLOAD_BROADCAST_ATTACHMENTS = gql`
  mutation UploadBroadcastAttachments($input: BroadcastUploadAttachmentsInput!) {
    broadcast {
      uploadAttachments(input: $input) {
        error
        success
      }
    }
  }
`;
